import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GenericService } from '../../generic.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { LandingService } from '../../landing-page/service/landing.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-pop-up',
    imports: [CommonModule],
    templateUrl: './pop-up.component.html',
    styleUrl: './pop-up.component.scss'
})
export class PopUpComponent {
  deviceData: any = {};
  deviceData$: any = null;
  @Input() visible: boolean = false;
  @Input() images: string[] = [];
  @Input() altText: string = '';
  @Output() closeEvent = new EventEmitter<void>();
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private genericService: GenericService,
    private crowdinService: CrowdinService,
    private landingService: LandingService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();
    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  close() {
    this.closeEvent.emit();
  }
}
